import { PAGE_TYPES } from "@constants/pageTypes";
import { getCurrentPageType } from "@utils/utils";

const PAGE_NAME_MAP: Record<string, string> = {
  cars: PAGE_TYPES.BUY_HOMEPAGE,
  gallery: PAGE_TYPES.GALLERY_PAGE,
  price: PAGE_TYPES.PRICE_PAGE,
  mileage: PAGE_TYPES.MILEAGE_PAGE,
  collection: PAGE_TYPES.COLLECTION_PAGE,
  faqs: PAGE_TYPES.FAQS_PAGE,
  dimensions: PAGE_TYPES.DIMENSIONS_PAGE,
  images: PAGE_TYPES.IMAGE_PAGE,
  variants: PAGE_TYPES.VARIANT_PAGE,
  search: PAGE_TYPES.SEARCH_PAGE,
  wishlist: PAGE_TYPES.WISHLIST_PAGE,
  review: PAGE_TYPES.REVIEW_PAGE,
  quote: PAGE_TYPES.QUOTE_PAGE,
  mm: PAGE_TYPES.MM_PAGE,
  mmv: PAGE_TYPES.MMV_PAGE,
  compare: PAGE_TYPES.COMPARISON_PAGE,
  onboarding: PAGE_TYPES.ONBOARDING_PAGE,
  "booking-confirmation": PAGE_TYPES.BOOKING_CONFIRMATION_PAGE ,
  "payment-success": PAGE_TYPES.PAYMENT_SUCCESS_PAGE,
  "final-quote": "Final Quote page",
  "variant-selection": PAGE_TYPES.VARIANT_SELECTION_PAGE,
  colors: PAGE_TYPES.COLOURS_PAGE,
  "specs-and-features": PAGE_TYPES.SPECS_PAGE,
  specifications: PAGE_TYPES.SPECS_PAGE,
  colours: PAGE_TYPES.COLOURS_PAGE,
};

export function getPageNameFromUrl(urlOrPath: string): string {

  const pageName = getCurrentPageType();
  try {
    const pathname = urlOrPath.startsWith('http')
      ? new URL(urlOrPath).pathname
      : urlOrPath;

    const segments = pathname.split('/').filter(segment => segment);

    if (segments.length === 0) {
      return 'Homepage';
    }

    const lastSegment = segments[segments.length - 1];
    if (segments.length >= 4 && segments.includes('cars')) {
      const carsIndex = segments.findIndex(seg => seg === 'cars');
      if (carsIndex !== -1 && carsIndex < segments.length - 2) {
        const pageType = segments[carsIndex + 2];
        if (PAGE_NAME_MAP[pageType]) {
          return PAGE_NAME_MAP[pageType];
        }
      }
    }

    if(pageName == "MMV page"){
      return PAGE_TYPES.MMV_PAGE;
    }

    if (segments.length > 1 && segments[0] === "cars") {
      return PAGE_TYPES.MM_PAGE;
    }

    if (segments.length === 1 && segments[0] === "cars") {
      return PAGE_TYPES.BUY_HOMEPAGE;
    }

    if (PAGE_NAME_MAP[lastSegment]) {
      return PAGE_NAME_MAP[lastSegment];
    } else if (lastSegment.includes("price-in")) {
      return PAGE_NAME_MAP["price"];
    }

    for (let i = segments.length - 1; i >= 0; i--) {
      const segment = segments[i];
      if (PAGE_NAME_MAP[segment]) {
        return PAGE_NAME_MAP[segment];
      }
    }

    return 'Home';
  } catch (error) {
    console.error('Error parsing URL for page name:', error);
    return '';
  }
}